// src/reducers/index.js
import { combineReducers } from 'redux';

import loginSlice from './slice/loginSlice';
import userServerDataSlice from './slice/userServerDataSlice';
import setCommonSlice from './slice/comonSlice';
import { toggleReducer } from './slice/toggleSlice'; // Correct import
import { videoToggleReducer } from './slice/videoToggleSlice';
import { exportProgressReducer } from './slice/exportProgressSlice';

const rootReducer = combineReducers({
  user: loginSlice,
  setUserInfo: userServerDataSlice,
  setCommon: setCommonSlice,
  setToggle: toggleReducer, // Use toggleReducer here
  setVideoToggle: videoToggleReducer,
  setExportProgress: exportProgressReducer,
});

export default rootReducer;